import Vue from 'vue';

export default Vue.component('ed-portal-info-section-course-name', {
  props: [],
  data: () => {
    return {
      form: [],
      sectionId: null,
      editionMode: false
    }
  },
  created() {
  },
  methods: {
    loadInfo() {
    }
  },
  watch: {
    $route() {
      this.loadInfo();
    }
  }
});


